import { Method, send } from '../../lib/MyHttp';

/**
 * 정보
 */
export const GetDayInfo = (component, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/statistics/day', params, success, fail);
};

/**
 * 정보
 */
export const GetMonthInfo = (component, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/statistics/month', params, success, fail);
};
